import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { sendLinear } from "~/features/configurator/Linear/api/sendLinearCommon";
import { type KmatType } from "~/features/configurator/Linear/kmatType";
import { buildConfiguratorMutationCommand } from "~/features/configurator/common/api/configuratorCommands";

export type CsticUpdate = {
  key: string;
  type: KmatType;
  index?: number;
  value: string | null;
};

export function sendLinearUpdate(
  linearState: LinearConfiguratorState,
  updatedCstics: CsticUpdate[],
): Promise<LinearConfiguration | null> {
  const result = buildConfiguratorMutationCommand(linearState, updatedCstics);
  return result.kind === "local-only" ? Promise.resolve(null) : sendLinear(result.command);
}
